<template>
  <div class="card-body">
    <div class="mb-3">
      <argon-input
        type="email"
        placeholder="Email"
        name="email"
        size="lg"
        v-model:value.sync="email"
      />
    </div>
    <div class="text-center">
      <argon-button
        class="mt-4"
        variant="gradient"
        color="success"
        fullWidth
        size="lg"
        :isLoading="resetButtonClicked"
        :isLoadingText="'Resetting...'"
        @click="resetPassword"
        >Reset My Password</argon-button
      >
    </div>
  </div>
</template>

<script>
import { ArgonInput, ArgonButton } from "@/components/exporter.js";
import { Validator } from "@/customFunctions/Validator.js";
import { Toaster } from "@/customFunctions/Utils.js";
import { SendPOSTUserAPI } from "@/customFunctions/Api.js";

export default {
  name: "inputs-container",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      email: "",
      resetButtonClicked: false,
    };
  },

  methods: {
    async resetPassword() {
      this.resetButtonClicked = true;
      try {
        if (!this.Validate()) {
          this.resetButtonClicked = false;
          return;
        }

        const resetPasswordResponse = await SendPOSTUserAPI(
          "users/reset-password",
          null,
          { username: this.email }
        );

        const isOk = resetPasswordResponse.statusCode === 200;

        if (isOk) {
          this.resetButtonClicked = false;
          this.$router.push({ path: "resetPassword" });
          return;
        }

        this.Toaster("Incorrect Email", "Error", "danger");
      } catch (e) {
        console.log(e, "resetPassword exception");
      }

      this.resetButtonClicked = false;
    },
    Validate() {
      Validator.validateEmail(this.email);
      return !Validator.validateIfHasError(this.Toaster);
    },
  },
  setup() {
    return { Toaster };
  },
};
</script>
